export enum ContractsQueryParams {
  businessUnits = 'contract_business_units',
  owners = 'sales_representative_users',
  statusAt = 'status_at',
  reminderStatus = 'reminder_status'
}
